import styled from "styled-components";
import Fundo from '../img/Fundo_Ribbon.png';

export const DivRibbons = styled.div`
    position: relative;
    margin: 2vh auto 0;
    width: 85.9%;
    aspect-ratio: 1920 / 594;
    overflow: hidden;
    border-radius: 6px;
    border: 2px solid #d5d5d5;
    box-sizing: border-box;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background-image: url(${Fundo});
    background-size: cover;
    background-position: bottom center;
    background-repeat: no-repeat;

    .conteudo {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        padding: 1.8% 3%;
        box-sizing: border-box;
    }

    h1 {
        margin: 0 0 0.4% 0;
        font-size: 2.2vw;
        font-weight: 900;
        color: #171717;
    }

    .intro {
        margin: 0 0 1.2%;
        min-height: 2.05vw;
    }

    .cards {
        flex: 1;
        display: flex;
        gap: 1.2vw;
        min-height: 0;
    }

    .card {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: rgba(255, 255, 255, 0.55);
        border-radius: 0.8vw;
        padding: 0.6vw;
        min-width: 0;

        h2 {
            margin: 0 0 0.3vw;
            font-size: 1.05vw;
            font-weight: 800;
            color: #171717;
            text-align: center;
        }

        img {
            flex: 1;
            width: 100%;
            height: 100%;
            min-height: 0;
            object-fit: contain;
        }

        p {
            margin: 0.3vw 0 0;
            font-size: 0.68vw;
            line-height: 1.25;
            font-weight: 600;
            color: #262626;
            text-align: center;
        }
    }

    .linha-final {
        position: absolute;
        left: 3%;
        bottom: 4%;
        width: 28%;
        height: 0.3vw;
        background-color: #F5A623;

        .quadrado {
            position: absolute;
            top: 50%;
            right: -1vw;
            transform: translateY(-50%);
            width: 1vw;
            height: 1vw;
            background-color: #F5A623;
        }
    }

    @media screen and (max-width: 750px) {
        aspect-ratio: auto;
        width: 100%;
        margin: 0px;
        border-radius: 0px;

        .conteudo {
            position: static;
            padding: 6vw 5vw 10vw;
        }

        h1 {
            font-size: 6vw;
            text-align: center;
        }

        .intro {
            min-height: 6vw;
        }

        .cards {
            flex-direction: column;
            gap: 4vw;
        }

        .card {
            padding: 4vw;

            h2 {
                font-size: 5vw;
            }

            img {
                max-height: 35vw;
                margin: 2vw 0;
            }

            p {
                font-size: 3.2vw;
            }
        }

        .linha-final {
            display: none;
        }
    }
`;
